import CanvasInput from './gameobjects/dynamictext/canvasinput/CanvasInput.js';
export default CanvasInput;